import React from 'react';
import { Link } from 'react-router-dom';
import { smsProgram } from '../data/smsProgram';

// Informational links only. Website form submissions do not provide SMS consent.
export function FormPolicyLinks() {
  return <div className="mt-3 flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-[12px] leading-relaxed" data-id="element-173" data-mp="1ctysukxpxxy">
      <Link to={smsProgram.privacyPath} target="_blank" rel="noopener noreferrer" className="text-chalk/70 underline underline-offset-2 hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-brand-light" data-id="element-174" data-mp="6adgk4gucsun">
        Privacy Policy
      </Link>
      <Link to={smsProgram.termsPath} target="_blank" rel="noopener noreferrer" className="text-chalk/70 underline underline-offset-2 hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-brand-light" data-id="element-175" data-mp="3jhf6hfci5pov">
        SMS Terms
      </Link>
    </div>;
}